import React, { useRef, useState, useEffect } from "react";
import { Link } from "gatsby";
import "./articlesFilterBar.scss";

function ArticlesFilterBar({ tags = [], selectedTag = "", onTagSelect }) {
  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setShowLeftArrow(el.scrollLeft > 10);
    setShowRightArrow(el.scrollLeft < el.scrollWidth - el.clientWidth - 10);
  };

  useEffect(() => {
    checkScroll();
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, [tags]);

  const scroll = (direction) => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollBy({ left: direction * 200, behavior: "smooth" });
  };

  return (
    <div className="articles-filter-bar">
      <div className="filter-bar-inner body-container">
        <div className="filter-label">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
          </svg>
          <span>Filter</span>
        </div>

        <div className="filter-scroll-wrapper">
          {showLeftArrow && (
            <button
              className="filter-scroll-btn filter-scroll-btn--left"
              onClick={() => scroll(-1)}
              aria-label="Scroll left"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>
          )}

          <div
            className="filter-tags-scroll"
            ref={scrollRef}
            onScroll={checkScroll}
          >
            <Link
              to="/insights/articles"
              className={`filter-tag ${
                !selectedTag || selectedTag === "all"
                  ? "filter-tag--active"
                  : ""
              }`}
            >
              All Articles
            </Link>
            {tags.map((tag, index) => (
              <Link
                key={index}
                to={`/insights/articles?tag=${tag.slug}`}
                className={`filter-tag ${
                  tag.type === selectedTag ? "filter-tag--active" : ""
                }`}
              >
                <span className="tag-hash">#</span>
                {tag.type}
              </Link>
            ))}
          </div>

          {showRightArrow && (
            <button
              className="filter-scroll-btn filter-scroll-btn--right"
              onClick={() => scroll(1)}
              aria-label="Scroll right"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ArticlesFilterBar;
